<template>
    <div class="m-rights-member-add" v-if="logined && bus.code !== 83001003 && bus.username">
        <h4 class="title">添加成员</h4>
        <div class="content">
            <div class="detail">
                <div class="item search-info">
                    <label class="label">mid</label>
                    <div class="search" :class="{'disabled': isDisable}">
                        <el-input v-model="mid" :placeholder="isDisable ? '添加人数已达上限' : '请输入成员的mid账号'" :disabled="isDisable" class="search-input" @blur="blurMid"></el-input>
                        <btn :type="0" info="搜索" :width="75" :height="34" :size="12" @click="search"></btn>
                    </div>
                    <div class="tips" :class="{'err': msg}" v-if="!isDisable">{{msg || '输入mid搜索，可绑定多个mid账号'}}</div>
                    <div class="result">
                        <div>剩余可添加人数：{{leaveNo}}</div>
                        <div class="member-list">
                            <div class="member" v-for="item in addTodoList" :key="item.mid" :style="`background: url(${item.face}) no-repeat 0 0 / 60px 60px`">
                                <div class="delete-btn" @click="deleteMember(item)"></div>
                                {{item.nickName}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="item config-info">
                    <label class="label">权限设置</label>
                    <div class="header"><span>基本信息</span><span>允许访问</span></div>
                    <div class="config-list">
                        <div class="config" v-if="isAddMember">
                            <div class="desc">
                                <div class="tit">开发者权限</div>
                                <div class="tips">可使用开发者工具(IDE)、上传开发预览版、可访问体验版小程序</div>
                            </div>
                            <div class="status">
                                <el-checkbox v-model="developer" true-label="1" false-label="0"></el-checkbox>
                            </div>
                        </div>
                        <div class="config" v-if="!isAddMember">
                            <div class="desc">
                                <div class="tit">预览权限</div>
                                <div class="tips">可扫码优先预览即将发布的小程序</div>
                            </div>
                            <div class="status">
                                <el-checkbox v-model="preview" true-label="1" false-label="0"></el-checkbox>
                            </div>
                        </div>
                        <div class="config" v-if="isAddMember">
                            <div class="desc">
                                <div class="tit">运营权限</div>
                                <div class="tips">可修改设置模块（暂停服务、最低支持版本修改、域名配置等），开发管理模块（发布上线、版本回退），可访问体验版小程序</div>
                            </div>
                            <div class="status">
                                <el-checkbox v-model="operation" true-label="1" false-label="0"></el-checkbox>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="item">
                    <btn :type="0" info="确认添加" @click="addMembers"></btn>
                </div>
                <div class="item qrcode-content">
                    <div class="tip">使用哔哩哔哩APP扫描下方二维码，可识别当前app内登录帐号的mid</div>
                    <img :src="codeUrl" class="qrcode" width="200">
                </div>
            </div>
        </div>
    </div>
    <access-deny v-else></access-deny>
</template>
<script>
import Btn from '@/components/Button.vue';
import AccessDeny from '@/components/AccessDeny.vue';
import QRCode from 'qrcode';

import dao from '@/lib/dao';
import bus from '@/lib/bus';

const LIMIT = 50;

export default {
    components: {
        Btn,
        AccessDeny
    },
    computed: {
        isDisable() {
            return LIMIT === this.addedNo + this.addTodoList.length;
        },
        leaveNo() {
            return LIMIT - this.addedNo - this.addTodoList.length;
        }
    },
    data() {
        return {
            appId: '',
            mid: '',
            addedNo: 0,
            msg: '',
            addTodoList: [],
            developer: '1',
            preview: '0',
            LIMIT,
            logined: true,
            bus,
            codeUrl: '',
            operation: '0',
            isAddMember: false
        };
    },
    methods: {
        blurMid() {
            if (!this.mid) {
                this.msg = '请输入mid号';
                return false;
            }
            if (!/^[0-9]+$/.test(this.mid)) {
                this.msg = 'mid账号必须为数字';
                return false;
            }
            let mid = parseInt(this.mid, 10);
            if (mid === bus.mid) {
                this.msg = '不能添加自己为小程序成员';
                return false;
            }
            if (this.addTodoList.some(item => item.mid === mid)) {
                this.msg = '该mid账号已添加，请勿重复添加';
                return false;
            }

            this.msg = '';
            return true;
        },
        search() {
            let result = this.blurMid();
            if (!result) return;

            dao.shop.searchByMid({
                appId: this.appId,
                mid: parseInt(this.mid, 10),
                userType: parseInt(this.$route.query.userType, 10)
            }).then(data => {
                this.mid = '';
                this.addTodoList.unshift({
                    face: data.face,
                    mid: data.mid,
                    nickName: data.nick
                });
            }).catch(msg => this.msg = msg);
        },
        deleteMember(item) {
            this.addTodoList = this.addTodoList.filter(ele => ele.mid !== item.mid);
        },
        addMembers() {
            if (this.addTodoList.length === 0) {
                this.$message({
                    type: 'error',
                    message: '至少添加一个成员',
                    duration: 2000
                });
                return;
            }
            dao.shop.addMembers({
                appId: this.appId,
                developer: parseInt(this.$route.query.userType, 10) === 3 ? '0' : this.developer,
                preview: this.preview,
                operation: this.operation,
                memberList: this.addTodoList,
                userType: parseInt(this.$route.query.userType, 10)
            }).then(data => {
                this.$router.push({
                    path: '/app/rightsmng/' + this.appId
                });
            }).catch(msg => {
                this.$message.error(msg);
            })
        },
        getQrcode() {
            QRCode.toDataURL('https://miniapp.bilibili.com/manager/deviceinfo')
                .then(url => {
                    this.codeUrl = url;
                })
                .catch(err => {
                    console.error(err)
                })
        }
    },
    mounted() {
        this.appId = this.$route.params.appId;
        this.isAddMember = this.$route.query.userType === 0 || this.$route.query.userType === '0';
        this.preview = this.$route.query.userType === '3' || this.$route.query.userType === 3 ? '1' : '0';
        this.addedNo = parseInt(this.$route.query.addedNo, 10);

        this.getQrcode();

        if (bus.username) {
            return;
        }
        dao.shop.getCompanyInfo().then(data => {
            bus.username = data;
            bus.type = 'shop';
            dao.shop.getAppDetail({ appId: this.appId }).then(data => {
                bus.smallAppName = data.name;
                bus.mid = data.mid;
            }).catch(msg => {
                this.$message.error(msg);
            });
        }).catch(response => {
            bus.code = response.code;
            if (response.code === 83001002) {
                this.logined = false;
            } else if (response.code !== 83001003) {
                this.$message.error(response.message);
            }
        });

    }
}
</script>

<style lang="less" scoped>
.m-rights-member-add {
    font-size: 12px;
    color: #5c667e;
    .title {
        font-size: 16px;
        font-weight: normal;
        margin: 0;
        margin-bottom: 5px;
    }
    .content {
        background-color: #fff;
        border: 1px solid #e0e5ec;
        padding: 25px 25px 35px;
        .detail {
            width: 814px;
            margin: 0 auto;
            .item {
                padding-left: 78px;
                position: relative;
                .label {
                    position: absolute;
                    text-align: right;
                    width: 62px;
                    left: 0;
                    line-height: 34px;
                }
                .tips {
                    color: #9aa7c1;
                    margin-top: 7px;
                }
                &.search-info {
                    .search {
                        display: flex;
                        .search-input {
                            width: 318px;
                            font-size: 12px;
                            margin-right: 7px;
                            input {
                                height: 34px;
                                line-height: 34px;
                                color: #9aa7c1;
                            }
                        }
                        &.disabled {
                            .add {
                                color: #9aa7c1;
                                background-color: #e0e5ec;
                            }
                            .el-input__inner {
                                color: #9aa7c1;
                                border-color: #e0e5ec;
                                background-color: #fff;
                            }
                        }
                    }
                    .tips {
                        &.err {
                            color: #ff7b58;
                        }
                    }
                    .result {
                        margin-top: 20px;
                        .member-list {
                            display: flex;
                            flex-wrap: wrap;
                            margin: 12px -15px 15px 0;
                            .member {
                                flex-basis: 60px;
                                padding-top: 64px;
                                text-align: center;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                                line-height: 18px;
                                margin-right: 15px;
                                margin-bottom: 15px;
                                position: relative;
                                .delete-btn {
                                    position: absolute;
                                    width: 60px;
                                    height: 60px;
                                    background: rgba(0, 0, 0, 0.6)
                                        url("../../assets/del@2x.png") no-repeat
                                        center/22px;
                                    top: 0;
                                    cursor: pointer;
                                    display: none;
                                }
                                &:hover {
                                    .delete-btn {
                                        display: block;
                                    }
                                }
                            }
                        }
                    }
                }
                &.config-info {
                    margin-bottom: 30px;
                    .header {
                        display: flex;
                        justify-content: space-between;
                        background-color: #f2f3f6;
                        height: 34px;
                        line-height: 34px;
                        padding: 0 10px;
                        color: #9aa7c1;
                    }
                    .config {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        padding: 15px 10px;
                        border-bottom: 1px solid #e7e7e7;
                        .el-checkbox.is-checked {
                            .el-checkbox__inner {
                                background-color: #789aff;
                            }
                        }
                    }
                }
                &.qrcode-content {
                    margin-top: 20px;
                }
            }
        }
    }
}
</style>




// WEBPACK FOOTER //
// src/page/manage/AddMembers.vue